import { IconMail } from '@tabler/icons-react';
import { ReactNode } from 'react';

import { Chip } from '@j-s/components';

export interface MessageModalHeaderProps {
  ticketNumber?: string;
  date?: number | string;
  subject: string;
  statusLabel: string;
  statusColor?: 'danger' | 'warning' | 'success' | 'default';
  icon?: ReactNode;
}

export function MessageModalHeader({
  ticketNumber = 'WIADOMOŚĆ',
  date,
  subject,
  statusLabel,
  statusColor,
  icon = <IconMail size={20} />,
}: MessageModalHeaderProps) {
  const formattedDate = date
    ? new Date(date).toLocaleString('pl-PL', {
        dateStyle: 'medium',
        timeStyle: 'short',
      })
    : null;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2.5 sm:gap-4 w-full">
      <div className="flex items-center gap-3 min-w-0 flex-1">
        <div className="w-10 h-10 rounded-xl bg-red-50 text-red-600 flex items-center justify-center shrink-0">
          {icon}
        </div>
        <div className="min-w-0 flex-1 flex flex-col justify-center gap-0.5">
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-mono font-bold text-red-600 text-xs tracking-wider">
              {ticketNumber}
            </span>
            {formattedDate && (
              <span className="text-xs text-gray-400 font-normal">
                • {formattedDate}
              </span>
            )}
          </div>
          <div
            className="font-bold text-gray-900 text-base leading-tight truncate"
            title={subject}
          >
            {subject}
          </div>
        </div>
      </div>
      <div className="shrink-0 self-start sm:self-center">
        <Chip size="sm" variant="soft" color={statusColor}>
          <span className="text-xs font-semibold whitespace-normal sm:whitespace-nowrap inline-block text-left sm:text-center max-w-[280px] sm:max-w-none">
            {statusLabel}
          </span>
        </Chip>
      </div>
    </div>
  );
}
